
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-success",
      function () {
        return require("private-next-pages/contact-success.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact-success"])
      });
    }
  